import { inject as t } from "vue";
const o = Symbol("cdnUrlInjection"), c = (n, { cdnUrl: r }) => {
  n.provide(o, r);
}, i = () => {
  const n = t(o);
  if (n === void 0)
    throw new Error("Cdn url injection was not provided");
  return n;
};
export {
  c as netflexCdnUrlPlugin,
  i as useCdnUrl
};
